import { Helmet } from "react-helmet-async";
import ReactHeader from "./reactHeader";
import TitleSection from "./titleSection";
import IntroSection from "./introSection";
import KhorAiSection from "./khorAiSection";
import PricingSection from "./pricingSection";
import FooterSection from "./footerSection";

function Home () {
    return (
        <div className="App">
            <Helmet>
                <title>Khor Developer | Excel-Native CRE Underwriting Software</title>
                <meta name="description" content="Institutional-grade commercial real estate underwriting software that runs natively inside Microsoft Excel. Deliver the rigor of ARGUS Enterprise within your team's existing workflow — no separate platform required." />
                <meta property="og:title" content="Khor Developer | Excel-Native CRE Underwriting Software" />
                <meta property="og:description" content="Institutional-grade commercial real estate underwriting software that runs natively inside Microsoft Excel. The ARGUS Enterprise alternative built for your existing workflow." />
                <meta property="og:url" content="https://www.khordeveloper.com/" />
                <meta property="og:type" content="website" />
                <meta property="og:image" content="https://www.khordeveloper.com/KhorDeveloperLong.png" />
                <link rel="canonical" href="https://www.khordeveloper.com/" />
            </Helmet>
            <ReactHeader />
            <TitleSection />
            <IntroSection />
            <KhorAiSection />
            <PricingSection />
            <FooterSection />
        </div>
    )
}

export default Home;
